import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import RmpMessageBox from "@rmp/core/components/common/RmpMessageBox.vue";
import { useI18n } from "vue-i18n-composable";
import { useMasterAccountAccessDocumentsStepStore } from "@rmp/id/stores/masterAccountAccess/steps/documents";
import { computed } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { MasterAccountApplicationMethodTypeEnum } from "@rmp/id/stores/masterAccountAccess/types/MasterAccountApplicationMethodTypeEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpFinalStep',
  setup(__props) {

const { tc } = useI18n();

const applicationStore = useMasterAccountAccessStore();

const useStore = useMasterAccountAccessDocumentsStepStore;

const accessReceived = computed(() => {
	return [
		MasterAccountApplicationMethodTypeEnum.BY_EMPLOYEE,
		MasterAccountApplicationMethodTypeEnum.BY_SIGNATURE
	].includes(applicationStore.applicationMethod);
});

const moveToHomePage = async () => {
	(window as Window).location = "/";
};

const { initialized } = usePage({ useStore });

return { __sfc: true,tc, applicationStore, useStore, accessReceived, moveToHomePage, initialized, RmpText, RmpIcon, RmpMessageBox }
}

})